export enum BOOKING_STATUSES {
  ACCEPTED = 'Accepted',
  PENDING = 'Pending',
  PAYMENT_PENDING = 'Payment_Pending',
}
